// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2MxlT","buttons":"Footer_buttons__2U-3O"};